import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
    selector: 'checkbox-dialog-component',
    styleUrls: ['checkbox.dialogcomponent.css'],
    templateUrl: 'checkbox.dialogcomponent.html'
})
export class CheckboxDialogComponent implements OnInit {
    title: string;
    message: string;
    inputhint: string;
    oktext: string;
    canceltext: string;
    checkboxlabel: string;
    checkboxoption: boolean;

    constructor(private dialogRef: MatDialogRef<CheckboxDialogComponent>, @Inject(MAT_DIALOG_DATA) private data: _CheckboxDialogOptions) {
        this.title = data.TitleText || 'Input Requested';
        this.message = data.MessageText || '';
        this.oktext = data.OKText || 'OK';
        this.canceltext = data.CancelText || 'Cancel';
        this.checkboxlabel = data.CheckboxLabel || '';
        this.checkboxoption = (data.CheckboxOption != null ? data.CheckboxOption : false);
    }

    ngOnInit() {
    }

    CancelHandler() {
        this.dialogRef.close(null);
    }

    OKHandler() {
        this.dialogRef.close(this.checkboxoption);
    }
}

// #region Custom Classes

export class _CheckboxDialogOptions {
    TitleText?: string;
    MessageText?: string;
    OKText?: string;
    CancelText?: string;
    IconColor?: string;
    IconName?: string;
    ShowIcon?: boolean;
    height?: string;
    width?: string;
    CheckboxLabel?: string;
    CheckboxOption?: boolean;
}

// #endregion


// WEBPACK FOOTER //
// ./src/services/dialogs/checkbox/checkbox.dialogcomponent.ts